module.exports = __webpack_public_path__ + "static/media/snow.35719e13.svg";